export const TOOL_TYPES = { JOB_DESCRIPTION: 'Job Description' };
export const COMPENSATION_TOOL = 'Compensation Tool';
export const LANDING = {
    MAIN_TITLE: 'HR Tools',
    MAIN_DESCRIPTION: 'HR Tools',
    DEFAULT_IMAGE:
        'https://s3-us-west-2.amazonaws.com/com.thinkhr-qa-fs/public/document/thumbnail/DefaultThumbnail.jpg',
    DEFAULT_TITLE: 'Templates',
    DOCUMENT_KEY: 'document',
    INTRODUCTION:
        'Get started creating job descriptions, benefit documents, and more. Use helpful calculators to project hiring costs. Find minimum wage information per state.',
    RECENT_DOCUMENTS: 'Recent Documents',
};
export const WIDGETS = {
    BDC: {
        DESCRIPTION:
            'Build and manage comprehensive benefit documents with an easy guided workflow.',
        FILTER: { text: 'What kind of form are you looking for?', placeholder: 'Category' },
        HEADER: {
            text: '',
        },
        FOOTER: {
            text: 'View All Documents',
        },
        ID: 'BDC',
        ITEMS: [
            { title: 'View Resources', path: '/hr-tools/benefits-document-creator/resources' },
            { title: 'View FAQ', path: '/hr-tools/benefits-document-creator/faq' },
        ],
        CREATE_DOCUMENT_LABEL: 'Create Document',
        PATH: '/hr-tools/benefits-document-creator/home',
        TITLE: 'Benefits Document Creator',
        BUTON_TEXT_VIEW: 'View Benefits Document',
        BUTON_TEXT_CREATE: 'New Benefits Document',
    },
    JDB: {
        BUTTON: {
            text: 'Create A Job Description',
            handler: 'checkCompanyListRedirectionByRole',
            path: '/hr-tools/job-description-builder/search',
        },
        CONTENT: {
            text:
                'Build meaningful job descriptions using an effective and simple guided step-by-step process.',
        },
        FOOTER: {
            text: 'Access Saved Job Descriptions',
        },
        ID: 'JDB',
        TITLE: 'Job Description Builder',
        PATH: '/hr-tools/job-description-builder/list',
        PENDO_CLASSNAME: 'pendo-handbook-icon',
        BUTON_TEXT: 'Create a Job Description',
    },
    MINIMUN_WAGE_MAP: {
        BUTTON_LABEL: 'GO',
        DROPDOWN_PLACEHOLDER: 'State',
        DESCRIPTION:
            'Use an interactive map to quickly view minimum wage rates and information across the US.',
        FILTER: {
            text: 'Choose a state:',
            placeholder: 'Select State',
        },
        ID: 'MWM',
        PATH: '/hr-tools/minimum-wage-map',
        TITLE: 'Minimum Wage Map',
        BUTON_TEXT: 'View by State',
    },
    CALCULATORS: {
        BUTTON_LABEL: 'GO',
        CALCULATORS: [
            { label: 'Cost Per Hire', value: '/hr-tools/calculators/cost-per-hire' },
            { label: 'Employee Turnover', value: '/hr-tools/calculators/employee-turnover' },
            { label: 'Absenteeism', value: '/hr-tools/calculators/absenteeism' },
            { label: 'Overtime', value: '/hr-tools/calculators/overtime' },
            {
                label: 'ACA Full-Time Equivalent',
                value: '/hr-tools/calculators/aca-full-time-equivalent',
            },
            { label: 'ACA Safe Harbor', value: '/hr-tools/calculators/safe-harbor' },
        ],
        DROPDOWN_PLACEHOLDER: 'State',
        DESCRIPTION:
            'Calculate your employee costs and obligations under the Affordable Care Act (ACA).',
        FILTER: {
            text: 'What do you want to calculate?',
            placeholder: 'Select',
        },
        FOOTER: {
            text: 'See All Calculators',
        },
        HEADER: {
            text: 'Calculators',
        },
        ID: 'CALCULATORS',
        PATH: '/hr-tools/calculators/list',
        TITLE: 'Calculators',
        BUTON_TEXT: 'Calculate Hiring Costs',
    },
    SCT: {
        DESCRIPTION:
            'Compare salaries and benefits for jobs by regional location, experience level, and more.',
        HEADER: {
            text: 'Salary Comparison Tool',
        },
        FOOTER: {
            text: 'Compare Salaries',
        },
        IMAGE:
            'https://cdn.trustmineral-staging.com/public/assets/calculators/hr-tools-landing-salary-comparison-tool.jpg',
        ID: 'SCT',
        PATH: '/hr-tools/salary-compare',
        TITLE: 'Salary Comparison Tool',
        BUTON_TEXT: 'Compare Salaries',
    },
};
export const LANDING_ROUTES = [
    {
        label: 'Benefits Document Creator',
    },
];
